import React from "react"
import { isMobile } from "react-device-detect"
import ActivityFeed from "../../components/home/components/ActivityFeed"
import ShowOfTheWeekSidebar from "../../components/home/components/ShowOfTheWeekSidebar"
import UserCalendar from "../../components/home/components/UserCalendar"
import Footer from "../../components/shared/Footer/Footer"
import Header from "../../components/shared/Header/Header"
import Heading from "../../components/shared/Heading"
import MakeStuff from "../../components/home/components/MakeStuff"
import CreatePlaylistForm from "../../components/CreatePlaylistForm"

interface NewPlaylistPageProps {
  user: {
    band_id: number
    enable_activity_feed?: boolean
  }
}

const NewPlaylistPage: React.FC<NewPlaylistPageProps> = ({ user }) => {
  return (
    <div className="">
      <Header user={user} />
      <div className="lg:grid lg:grid-cols-12 w-full pb-2 mt-4 px-3 lg:px-4 flex flex-col-reverse">
        <div className="lg:col-span-4 col-span-12 lg:pr-6">
          <MakeStuff />
          <ShowOfTheWeekSidebar className="mb-6" />
          {user && (
            <div className="mb-6">
              <UserCalendar user={user} />
            </div>
          )}
          {user && user.enable_activity_feed && !isMobile && (
            <div className="">
              <ActivityFeed />
            </div>
          )}
        </div>
        <div className="lg:col-span-8 col-span-12 lg:mt-0">
          <Heading level={2} type="sectionHeader">
            Create a Playlist
          </Heading>
          <CreatePlaylistForm bandId={user.band_id} />
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default NewPlaylistPage
